import axios from "axios";
import { USER_LOGGEDIN, SET_CURRENT_USER, CURRENT_ADMIN, ADMIN_ADDED, ADMINS_FETCHED, ADMIN_REMOVED, ROLES_FETCHED, ROLE_ADDED, ROLE_UPDATED, ROLE_DELETED } from "../types";
import { axiosInstance } from "../../config/index";

/**
 * Log in a user via active directory / LDAP.
 */
export const loginUser = (loginInfo: any) => (dispatch: any) => {
  const loginURL = `/api/auth/login`;
  return new Promise((resolve, reject) => {
    axios
      .post(loginURL, loginInfo, { withCredentials: true })
      .then((res) => {
        const user = res.data?.user;
        dispatch({
          type: USER_LOGGEDIN,
          user: res.data.user,
        });
        sessionStorage.setItem("loggedinUser", user?.oracleId);
        resolve(true);
      })
      .catch((err) => {
        console.error("[AUTH] Login error:", err?.response?.data || err);
        return reject(err?.response?.data);
      });
  });
};

/**
 * Log out the currently authenticated user.
 */
export const logoutUser = () => (dispatch: any) => {
  const logoutURL = `/api/auth/logout`;
  return new Promise((resolve, reject) => {
    axios
      .post(logoutURL)
      .then((res) => {
        const user = res.data?.user;
        dispatch({
          type: USER_LOGGEDIN,
          user,
        });
        sessionStorage.removeItem("loggedinUser");
        resolve(true);
      })
      .catch((err) => {
        return reject(err?.response?.data);
      });
  });
};

/**
 * Fetch details of the currently authenticated LDAP user.
 */
export const getCurrentuser = () => (dispatch: any) => {
  const currentUserUrl = `/api/auth/current-user`;
  return new Promise((resolve, reject) => {
    axios
      .get(currentUserUrl)
      .then((res) => {
        dispatch({
          type: SET_CURRENT_USER,
          user: res.data.user,
        });
        resolve(true);
      })
      .catch((err) => {
        console.error("[AUTH] Failed to fetch current user:", err?.response?.data || err.message);
        dispatch({
          type: SET_CURRENT_USER,
          user: null,
        });
        return reject(err?.response?.data);
      });
  });
};

export const addAdmin = (userId: string, roleIdOrIds?: string | string[]) => (dispatch: any) => {
  const payload = Array.isArray(roleIdOrIds) ? { roleIds: roleIdOrIds } : { roleId: roleIdOrIds };
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(`/api/auth/admins/${userId}`, payload)
      .then((res) => {
        dispatch({
          type: ADMIN_ADDED,
        });
        resolve(true);
      })
      .catch((err) => {
        console.error(err);
        reject(false);
      });
  });
};

/**
 * Fetch all registered system administrators.
 */
export const getAdmins = () => (dispatch: any) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(`/api/auth/admins`)
      .then((res) => {
        dispatch({
          type: ADMINS_FETCHED,
          admins: res.data.admins,
        });
        resolve(true);
      })
      .catch((err) => {
        console.error(err);
        reject(false);
      });
  });
};

/**
 * Demote/remove admin status from a user.
 */
export const removeAdmin = (userId: string) => (
  dispatch: any,
  getState: any
) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .delete(`api/auth/admins/${userId}`)
      .then((res) => {
        dispatch({
          type: ADMIN_REMOVED,
        });
        resolve(true);
        dispatch(getAdmins());
      })
      .catch((err) => {
        console.error(err);
        reject(false);
      });
  });
};

export const setCurrentAdmin = (singleAdmin: any) => {
  return { type: CURRENT_ADMIN, singleAdmin };
};

/**
 * Fetch all custom/system authorization roles.
 */
export const getRoles = () => (dispatch: any) => {
  return new Promise((resolve, reject) => {
    axiosInstance.get("/api/role")
      .then(res => {
        dispatch({ type: ROLES_FETCHED, roles: res.data });
        resolve(res.data);
      })
      .catch(err => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * Create a new authorization role.
 */
export const addRole = (roleData: any) => (dispatch: any) => {
  return new Promise((resolve, reject) => {
    axiosInstance.post("/api/role", roleData)
      .then(res => {
        dispatch({ type: ROLE_ADDED, role: res.data });
        resolve(res.data);
      })
      .catch(err => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * Update an existing authorization role.
 */
export const updateRole = (id: string, roleData: any) => (dispatch: any) => {
  return new Promise((resolve, reject) => {
    axiosInstance.put(`/api/role/${id}`, roleData)
      .then(res => {
        dispatch({ type: ROLE_UPDATED, role: res.data });
        resolve(res.data);
      })
      .catch(err => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * Delete an existing custom role.
 */
export const deleteRole = (id: string) => (dispatch: any) => {
  return new Promise((resolve, reject) => {
    axiosInstance.delete(`/api/role/${id}`)
      .then(res => {
        dispatch({ type: ROLE_DELETED, id });
        resolve(res.data);
      })
      .catch(err => {
        console.error(err);
        reject(err);
      });
  });
};
